/**
 * DatasetsPage Component
 *
 * Main page for browsing and downloading DCAT datasets
 * Features:
 * - Dataset list table with sorting
 * - Download, copy-link and Open-in-Yasgui actions
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container, PageHeader } from '@bn-apps/dim-ui-react';
import { useDatasets } from '@hooks/useSparql';
import DatasetList from '@components/datasets/DatasetList';
import routes from '@config/routes';
import appStyles from '@/App.module.scss';
import styles from './DatasetsPage.module.scss';

function DatasetsPage(): JSX.Element {
  const { t } = useTranslation();

  const {
    data: datasets,
    loading,
    error,
    refetch,
  } = useDatasets();

  return (
    <Container className={appStyles.pageContent}>
      <div className={styles.header}>
        <PageHeader
          title={t('datasets.title')}
          lead={
            <>
              {t('datasets.description')}{' '}
              <Link to={routes.helpDatasets}>{t('datasets.learnMore')} →</Link>
            </>
          }
        />
      </div>

      <main>
        <DatasetList
          datasets={datasets}
          loading={loading}
          error={error}
          onRefresh={refetch}
        />
      </main>
    </Container>
  );
}

export default DatasetsPage;
